import React, { useState, useEffect, useRef } from "react";
import { Dialog } from "primereact/dialog";
import { Button } from "primereact/button";
import { InputText } from "primereact/inputtext";
import * as Yup from "yup";
import { useFormik } from "formik";
import { useDispatch, useSelector, shallowEqual } from "react-redux";
// import { getBuilding, setDataNull2, setProduct } from "../../store/order/slice";
import {
    addClassification,
    updateClassification,
    setDataNull,
} from "../../store/classifications/slice";
import { Dropdown } from "primereact/dropdown";
import "../../assets/scss/theme-base/ModalAddDashbord.css";

const ModalAddClassifications = ({ visible, onHide, toast, rowData }) => {
    const dispatch = useDispatch();

    const { errorInsert, insertData, updateData, errorUpdate } = useSelector(
        (state) => ({
            errorInsert: state.Classifications.errorInsert,
            insertData: state.Classifications.insertData,
            updateData: state.Classifications.updateData,
            errorUpdate: state.Classifications.errorUpdate,
        }),
        shallowEqual
    );

    // Validation schema
    const validationSchema = Yup.object().shape({
        type: Yup.string().required("Loại là bắt buộc"),
        name: Yup.string().required("Tên phân loại là bắt buộc"),
    });

    const formik = useFormik({
        enableReinitialize: true,
        initialValues: {
            type: rowData?.type || "",
            name: rowData?.name || "",
            description: rowData?.description || "",
        },
        validationSchema: validationSchema,
        onSubmit: async (value) => {
            const data = {
                ...value,
                ...(rowData?.id ? { id: rowData.id } : {}),
            };

            if (rowData?.id) {
                dispatch(updateClassification({ data }));
            } else {
                dispatch(addClassification({ data }));
            }
        },
    });

    useEffect(() => {
        if (errorInsert) {
            toast.current?.show({
                severity: "error",
                summary: "Thất bại",
                detail: errorInsert?.response?.data?.message,
                life: 3000,
            });
            dispatch(setDataNull());
        }
        if (insertData) {
            toast.current?.show({
                severity: "success",
                summary: "Thành công",
                detail: "Thêm phân loại thành công",
                life: 3000,
            });
            formik.resetForm();
            dispatch(setDataNull());
            onHide();
        }
    }, [errorInsert, insertData]);
    useEffect(() => {
        if (errorUpdate) {
            toast.current?.show({
                severity: "error",
                summary: "Thất bại",
                detail: errorUpdate?.response?.data?.message,
                life: 3000,
            });
            dispatch(setDataNull());
        }
        if (updateData) {
            toast.current?.show({
                severity: "success",
                summary: "Thành công",
                detail: "Cập nhật phân loại thành công",
                life: 3000,
            });
            formik.resetForm();
            dispatch(setDataNull());
            onHide();
        }
    }, [errorUpdate, updateData]);

    return (
        <Dialog
            visible={visible}
            onHide={() => {
                formik.resetForm();
                onHide();
            }}
            header="Phân loại"
            modal
            style={{ width: "30%" }}
            className="responsive-dialog"
            footer={
                <div>
                    <Button
                        label="Hủy"
                        onClick={() => {
                            formik.resetForm();
                            onHide();
                        }}
                        severity="secondary"
                        className="p-button-text"
                    />
                    <Button
                        type="submit"
                        label="Lưu"
                        onClick={formik.handleSubmit}
                    />
                </div>
            }
        >
            <div className="bg-white p-3 border-round-md">
                <div className="flex flex-column mb-4 gap-3">
                    <div className="flex flex-column">
                        <label className="mb-2">Tên phân loại</label>
                        <InputText
                            id="name"
                            name="name"
                            value={formik.values.name}
                            onChange={formik.handleChange}
                            style={{ height: "40px" }}
                            className={
                                formik.touched.name && formik.errors.name
                                    ? "p-invalid"
                                    : ""
                            }
                        />
                        {formik.touched.name && formik.errors.name ? (
                            <div style={{ color: "red" }}>
                                {formik.errors.name.toString()}
                            </div>
                        ) : null}
                    </div>
                    <div className="flex flex-column w-12 mb-3">
                        <label className="mb-2">Loại</label>
                        <Dropdown
                            id="type"
                            name="type"
                            value={formik.values.type}
                            options={[
                                { label: "Sản phẩm", value: "product" },
                                { label: "Vật tư", value: "material" },
                            ]}
                            onChange={(e) =>
                                formik.setFieldValue("type", e.value)
                            }
                            onBlur={formik.handleBlur}
                            filter
                            style={{
                                height: "40px",
                                border: "1px solid #ddd",
                            }}
                            className={
                                formik.touched.type && formik.errors.type
                                    ? "p-invalid "
                                    : "border-300"
                            }
                        />
                        {formik.touched.type && formik.errors.type ? (
                            <div style={{ color: "red" }}>
                                {formik.errors.type.toString()}
                            </div>
                        ) : null}
                    </div>
                    <div className="flex flex-column">
                        <label className="mb-2">Ghi chú</label>
                        <InputText
                            id="description"
                            name="description"
                            value={formik.values.description}
                            onChange={formik.handleChange}
                            className={`responsive-input ${
                                formik.touched.description &&
                                formik.errors.description
                                    ? "p-invalid"
                                    : ""
                            }`}
                            style={{ height: "40px" }}
                        />
                        {formik.touched.description &&
                        formik.errors.description ? (
                            <div style={{ color: "red" }}>
                                {formik.errors.description.toString()}
                            </div>
                        ) : null}
                    </div>
                </div>
            </div>
        </Dialog>
    );
};

export default ModalAddClassifications;
